////////LIBRARY/////////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { cloneDeep, isEmpty, isUndefined, isEqual, find, replace } from 'lodash'
///////COMPONENTS///////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import TooltipHelp from '../../components/TooltipHelp'
import { addItemCatalogActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import { uriList } from '../../routings/settings/RouteList'
import { AddItemCatalogStatus, AddItemCatalogImg } from './Components'
import Modals from '../../components/Modals'
import StringFormatter from '../../helpers/StringFormatter'
import { TextModal } from '../../theme/GlobalCss'
import Button from '../../components/Ui/Buttons'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import theme from '../../theme/theme'
import TableTitle from '../../components/Table/components/TableTitle'
/////////ASSETS/////////
import Add from '../../assets/icones/global/add.svg'
import Less from '../../assets/icones/global/hyphen.svg'
import view from '../../assets/icones/global/view.svg'
import Validation from '../../assets/icones/global/check.svg'

/////////STYLED/////////
const AddItemCatalogWrapper = styled.div`
	position: relative;
`
const ButtonWrapperCustom = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: center;
	font-size: 13px;
`
/////////STYLED/////////

const AddItemCatalog = () => {
	const {
		userRolePrivileges,
		user,
		translations,
		addItemCatalog,
		addItemCatalogFilters,
		addItemCatalogIsUpdated,
		errorUnlink,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			addItemCatalog: state.addItemCatalog,
			addItemCatalogIsUpdated: state.addItemCatalog.isUpdated,
			addItemCatalogFilters: state.addItemCatalog.header,
			userRolePrivileges: state.user.identity.rolePrivileges,
			errorUnlink: state.addItemCatalog.errorUnlink,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)
	const actionsBindItemCatalog = bindActionCreators(addItemCatalogActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	let history = useHistory()
	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		nameDir: 'asc',
		sort: 'dateEnabled',
		sort_2: 'distributionGroup.company.labelToDisplay',
		nameDir_2: 'asc',
	})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modal

	const [showModalRmv, setShowModalRmv] = useState(false)
	const [showErrorUnlinkModal, setShowErrorUnlinkModal] = useState(false)
	const [textModal, setTextModal] = useState('')

	//Columns
	const [columns, setColumns] = useState([])

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}
	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleViewItems = (row) => {
		history.push(`${uriList.distributionItem}${uriList.distributionGroupRepositorytDetail}/${row.itemId}`)
	}

	const handleAddItemCatalog = (row) => {
		if (row.canLink) {
			actionsBindItemCatalog.putLinkCatalogItem(row.itemId)
		}
	}

	const handleRmvItemCatalog = (row) => {
		if (row.canUnlink) {
			actionsBindItemCatalog.putUnlinkCatalogItem(row.itemDistributorId)
		} else if (!row.canUnlink) {
			setShowModalRmv(true)
		}
	}

	const handlePagingDistribution = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'distributionGroup.company.labelToDisplay',
				nameDir: 'asc',
				sort_2: 'labelToDisplay',
				nameDir_2: 'asc',
			}
		}
		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsBindItemCatalog.postBindCatalog(filters, pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
		}
	}

	const handleModalErrorUnlink = () => {
		setShowErrorUnlinkModal(false)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'itemCatalog_distributorGrp',
				dataHook: 'labelDistributionGroup',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_distributionGroup'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'distributionGroup.company.labelToDisplay',
			},
			{
				columnReferential: 'itemCatalog_productImage',
				dataHook: 'itemPicture',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemPicture'],
				sortable: true,
				isAuthorize: true,
				component: AddItemCatalogImg,
				sortableId: 'picture',
			},
			{
				columnReferential: 'itemCatalog_itemName',
				dataHook: 'labelItem',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToDisplay',
			},
			{
				columnReferential: 'itemCatalog_state',
				dataHook: 'itemDistributorPresent',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemState'],
				sortable: true,
				isAuthorize: true,
				component: AddItemCatalogStatus,
				sortableId: 'itemDistributor.id',
			},
			{
				columnReferential: 'itemCatalog_availableDate',
				dataHook: 'availabiltyDate',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_availabilityDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.availabiltyDate === null ? '-' : moment(props.row.availabiltyDate).format('DD/MM/YYYY HH:mm')),
				sortableId: 'dateEnabled',
			},
			{
				columnReferential: 'itemCatalog_family',
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemFamily'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'family.label',
			},
			{
				columnReferential: 'itemCatalog_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemBrand'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'brand.label',
			},
			{
				columnReferential: 'itemCatalog_type',
				dataHook: 'itemType.translationKey',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_itemType'],
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemType.translationKey.id',
			},
			{
				columnReferential: 'itemCatalog_consignation',
				dataHook: 'withConsignment.translationKey',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_consignationEnable'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'withDeposit',
			},
			{
				columnReferential: 'itemCatalog_addDate',
				dataHook: 'addingDate',
				headerName: translations['page__itemCatalog__distributor__link__tableHeader_addDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (props.row.addingDate === null ? '-' : moment(props.row.addingDate).format('DD/MM/YYYY HH:mm')),
				sortableId: 'itemDistributor.dateEnabled',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: true,
				hasActionIconsDisplay: true, //to set width on cells action, remove it when we refact action ActionPaper component
				rest: {
					tooltipPart: 'catalog',
					paperActionsList: [
						{
							translationKey: 'tooltip__admin__itemCatalog__distributor_showItem',
							clickAction: (row) => {
								handleViewItems(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[31])),
							iconDef: view,
						},
						{
							translationKey: 'tooltip__admin__itemCatalog__distributor_addItem',
							clickAction: (row) => {
								handleAddItemCatalog(row)
							},
							isVisible: (row) =>
								row.canLink === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[21])),
							icon: Add,
							bgColor: theme.colors.primary,
							hover: theme.colors.wedealBlueOther,
						},
						{
							translationKey: 'tooltip__admin__itemCatalog__distributor_removeItem',
							clickAction: (row) => {
								handleRmvItemCatalog(row)
							},
							isVisible: (row) =>
								row.canUnlink === true &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[21])),
							icon: Less,
							bgColor: theme.colors.error,
							hover: theme.colors.hoverError,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 2,
		labelPageTable: 'itemCatalog',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingDistribution(paging),
		},
	})
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (addItemCatalogIsUpdated) {
			actionsBindItemCatalog.postBindCatalog(filters, paging)
		}
	}, [addItemCatalogIsUpdated])
	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)
		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)

		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', nameDir: 'asc', sort: 'dateEnabled', sort_2: 'distributionGroup.company.labelToDisplay', nameDir_2: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsBindItemCatalog.postBindCatalog(handleFilterSend(), pg)
	}

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(addItemCatalog) && !isUndefined(addItemCatalog)) {
			cfg.paging = {
				totalElements: addItemCatalog.paging.totalElements,
				totalPages: addItemCatalog.paging.totalPages,
				fnSendTo: (paging) => handlePagingDistribution(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [addItemCatalog])

	useEffect(() => {
		if (isUndefined(searchValue)) return
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === addItemCatalog) return

		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		if (!isEmpty(translations)) {
			const filtersCp = cloneDeep(addItemCatalogFilters)
			filtersCp.withFilters = true
			setFilters(filtersCp)
			setPrevFilter(filtersCp)
		}
	}, [addItemCatalogFilters, translations])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.paging = {
			totalElements: addItemCatalog.paging.totalElements,
			totalPages: addItemCatalog.paging.totalPages,
			fnSendTo: (paging) => handlePagingDistribution(paging),
		}
		cfg.name = [
			<TooltipHelp content={'tooltip__admin__itemCatalog__distributor_page'} childrenPos={1}>
				{translations['page__itemCatalog__distributor__link__title']}
			</TooltipHelp>,
		]

		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		}

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_brandLabel']}
					data={filters.filtersSelection?.itemBrand.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemBrand'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemType']}
					data={filters.filtersSelection?.itemType.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemType'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemFamily']}
					data={filters.filtersSelection?.itemFamily.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemFamily'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_itemState']}
					data={filters.filtersSelection?.itemState.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'itemState'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['common__fastFilter_distributoinGroup']}
					data={filters.filtersSelection?.distributionGroup.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'distributionGroup'}
				/>
			),
		]

		setConfigTableTitle(cfg)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				withFilters: false,
				filtersSelection: null,
				searchFieldUpdated: false,
			}
			actionsBindItemCatalog.postBindCatalog(filtersCp)
			setFilters(filtersCp)
			setConfigTable({ ...configTable, export: { bd: filtersCp } })
			actionsColumns.setColumns([])
		}
	}, [addItemCatalog, translations])

	useEffect(() => {
		if (!isEqual(errorUnlink, {})) {
			setShowErrorUnlinkModal(true)
			setTextModal(errorUnlink?.msgParameters[0])
		}
	}, [errorUnlink])

	// We transform text to display
	let article = `<span style="color: ${theme.colors.primary}" > [${textModal}] </span>`
	let text = StringFormatter.ResponseMessageParser(
		replace(translations['common__message__itemCatalog__link__removeItem_error_stock'], '\\n', '<br>'),
		[article]
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={addItemCatalog.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={addItemCatalog.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsBindItemCatalog.postBindCatalog}
			/>
		)
	}, [addItemCatalog, columns, translations, configTable, paging])

	return (
		<Fragment>
			{/* MODAL ERROR CAN T UNLINK*/}
			{showErrorUnlinkModal && (
				<Modals
					title={translations['modal__itemCatalog__distributor__link__removeError_title']}
					closeModalHandler={handleModalErrorUnlink}
					showModal={showErrorUnlinkModal}
					//level={(row.canEnabled && row.isDisable) ? "" : "error"}
					icon={true}
				>
					<TextModal dangerouslySetInnerHTML={{ __html: text }}></TextModal>
					<ButtonWrapperCustom>
						<Button
							actionHandler={handleModalErrorUnlink}
							text={translations['common__text__ok']}
							bgColor={theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapperCustom>
				</Modals>
			)}
			{/* TABLEAU */}

			<AddItemCatalogWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</AddItemCatalogWrapper>
		</Fragment>
	)
}

AddItemCatalog.propTypes = {}

AddItemCatalog.defaultPropTypes = {}

export default AddItemCatalog
